import { Checkbox as PrimeCheckbox } from "primereact/checkbox";
import { classNames } from "primereact/utils";
import React from "react";

interface CheckboxProps {
  id?: string;
  name?: string;
  value?: boolean;
  label?: string;
  labelPosition?: "before" | "after";
  subLabel?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  error?: string;
  onChange?: (e: any) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  checked: boolean;
}

export function Checkbox({
  id,
  name,
  value,
  label,
  subLabel,
  disabled = false,
  required = false,
  className,
  error,
  onChange,
  onClick,
  checked,
  labelPosition = "after",
}: CheckboxProps) {
  return (
    <div className={"flex gap-2 items-center w-fit " + (disabled ? " opacity-60" : "")}>
      {" "}
      {label && labelPosition === "before" && (
        <div className={"mb-2"}>
          <label htmlFor={id} className={`block`}>
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </label>
          {subLabel && <span className={"text-neutral-500 text-sm"}>{subLabel}</span>}
        </div>
      )}
      <PrimeCheckbox
        inputId={id} // pass id to the underlying input
        checked={checked}
        onChange={onChange} // single source of change
        onClick={onClick}
        className={classNames("w-fit", { "p-invalid": error }, className)}
        disabled={disabled}
        value={value}
        name={name}
      />
      {label && labelPosition === "after" && (
        <div className={"mb-2"}>
          <label htmlFor={id} className={`block`}>
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </label>
          {subLabel && <span className={"text-neutral-500 text-sm"}>{subLabel}</span>}
        </div>
      )}
    </div>
  );
}
